import { FormattedMessage} from 'react-intl';
import React, {Component, useEffect, useState} from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import {Link} from "react-router-dom";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";
import { Container, Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import MyUploader from "../../elements/UploadDDL";
import FilesTable from "../Assesment/table";
import ModalExample from "../../elements/PopupWindow";
import {config} from "../../../utility/swaggerClient";

const messages = {
  htmlHeader: {
    id: 'translation.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Translation'
  },
  headerTitle: "My Data Factory",
  headerSubTitle: "Upload/Update DDL files for development test enviorment"

};

let confirmation =()=>{};
const ManagementDDL = (props) => {

  useEffect(() => {
    // if(props.role.includes('TRANSLATION_LEAD') || props.role.includes('DATA_ENGINEER')){
      if(true){
      props.getCustomers();
      props.resetCustomersPrjList();
      props.resetStagingPrjList();
      setCustomer(props.match.params.customer);
      setReponame(props.match.params.reponame);
      setDfid(props.match.params.dfid);
     //alert(props.match.params.selectedjdbclength)
     //console.log("ok");
      props.docheckddlexist(props.match.params.customer, props.match.params.reponame,'DDLPage',setDisabledownload);

    }else{
      props.customersPrjList('Translation', props.customerid);
    }

  }, []);



  const [showEditor, setShowEditor] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [repo, setRepo] = useState("");
  const [customer, setCustomer] = useState("");
  const [reponame, setReponame] = useState("");
  const [dfid, setDfid] = useState("");
  const [stagingrepo, setStagingrepo] = useState("");
  const [refId, setRefId] = useState("");
  const [srclang, setSrclang] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("");
  const [description, setDescription] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [uploadcontent, setUploadcontent] = useState("");
  const [disableUploadBack, setDisableUploadBack] = useState("");
  const [disableupload, setDisableupload] = useState(false);
  const [disabledownload, setDisabledownload] = useState(true);
  const jobType = "Translation";

  const sourceCodedownload = (customerid,reponame)=>{
    //console.log(this.state.stagingrepo);
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
   // fetch(`${config.protocol}://${config.host}/api/user/download/${customerid}/${reponame}`, requestOptions)
   fetch(`${config.protocol}://${config.host}/api/user/downloadddl/${customerid}/${reponame}`, requestOptions)
      .then(response =>
      {
        console.log(response)
        // if(response.status === 200){
        //   throw new Error("woops");
        // }
        return response.blob()
      })
      .then(data => {
        console.log(data)
        const FileDownload = require("js-file-download");
        FileDownload(data, props.match.params.reponame + '.sql');
       // FileDownload(data, "Source Code.zip");
      }).catch(err => console.log(err));
  };

  const selectCus = (e)=>{
    setCustomer(e.target.value);
    props.customersPrjList("Translation",e.target.value);
  };

  const showMessageTrue = (e) => {
    setShowMessage(true);
    setRefId(e.value.data);
  };

  const getStagingRepo = (jobtype,_repo)=>{
    setStagingrepo("");
    setRepo(_repo);
    props.getinfobyreponameforaccessment(_repo,customer,jobType,updateSrcTar);
    props.getStagingPrjList(jobtype,_repo,customer);
  }

  const updateSrcTar = (e)=>{
    setTargetLanguage(e.value.data.tgtlang);
    setSrclang(e.value.data.srclang);
    setDescription(e.value.data.description);
  }

  const showNPupload =(type)=>{
    messages.headerSubTitle = type === "upload" ? "Upload source code" : "Update source code";
    setUploadType(type);
    setShowUpload(true);
    const prj = type === 'upload' ? `${repo}_${Date.now()}` : stagingrepo;
    setProjectName(prj);
  }

  const showNPuploadFlase =()=>{
    messages.headerSubTitle = 'Commercial code translation request';
    // getStagingRepo(jobType,repo);
    props.getStagingPrjList(jobType,repo,customer);
    setShowUpload(false);
    setDisableupload(false);
  }
  const uploadstatus = null;

  const showUploadFalse = ()=>{
    props.customersPrjList('Translation', props.customerid);
    setShowUpload(false);
    setDisableupload(false);
    messages.headerSubTitle = 'Commercial code translation request';
  }

  const showUploadTrue = (type)=>{
    messages.headerSubTitle = type === "upload" ? "Upload source code" : "Update source code";
    setUploadType(type);
    if(type === "upload"){
      setShowUpload(true);
      setProjectName("");
    }else{
      setShowUpload(true);
      setProjectName(repo);
    }
  }

  const gotoFileList = ()=>{
    if(srclang !== "" && targetLanguage !== "" && repo !== ""
      && srclang !== null && targetLanguage !== null && repo !== null
    ){
      getFilesList();
    }
  }

  const getFilesList = ()=>{
    setShowFiles(true);
    props.getfilesList(repo,props.customerid);
  }

  const changeRepo = (e)=>{
    setRepo(e.target.value)
    props.getinfobyreponameforaccessment(e.target.value,props.customerid,jobType,updateSrcTar);
  }

  const _setDisableUploadBack = (val)=>{
    setDisableUploadBack(val);
  }

  const setPrjName = (name)=>{
    setProjectName(name);
  }


  const submitRequest = ()=>{
    confirmation();
  }
  const confirmationSubmit = ()=>{
    props.userRequest(
      props.username,
      repo,
      srclang,
      targetLanguage,
      description,
      jobType,
      props.customerid,
      showMessageTrue
    );
  }
  const confirmationText = "You are about to Submit the uploaded code for commercial translation.  <br /><br />" +
    "Your request will be reviewed and approved by your Administrator.<br /><br />" +
    "Click SUBMIT to send your request to your Administrator.<br />"


  const checkuploadinlist = (prj,type)=>{
    if(type !== 'internal_assessment' && type !== 'internal_translation'){
      props.customersPrjList('Translation', props.customerid);
      // if(props.customerprojectList.includes(prj)){
        setRepo(prj);
      // }
      // console.log(props);
      // console.log(r.customerprojectList.includes(prj));
      // return props.customerprojectList.includes(prj);
      return true;
    }else{
      props.getStagingPrjList(jobType,repo,customer);
      // if(props.stagingprojectList.includes(prj)){
        setStagingrepo(prj);
        console.log(stagingrepo);
        console.log(prj);
      // }

      // return props.stagingprojectList.includes(prj);
      return true;
    }
  }


  // if(props.role.includes('TRANSLATION_LEAD') || props.role.includes('DATA_ENGINEER')){
    if(true){
    return (
      <div className="preview page">
        <Helmet>
          Translation - FUSE
        </Helmet>
        <Header
          title={messages.headerTitle}
          subtitle={messages.headerSubTitle}
          icon="preview"
          locale={props.locale}
          status = {props.status}
        />

        <div className="main">
          <div
            className="panel"
            style={{
              width: '90%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto',
              height:'100%'
            }}
          >

            {/* {!showMessage && ( */}
            {true && (
              <div>
                {/* {showUpload ? ( */}

                  <div className="form">
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="data.factory.name"
                        defaultMessage="Data Factory Name"
                      />
                    </label>

                    <Control.text
                      model=".projectName"
                      value= {props.match.params.reponame}
                      //value={projectName}
                      placeholder={uploadType==='upload' ?"same as zip file name" : ""}
                      disabled
                    />
                    <br />
                    <br />  <br />
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="dfddl.hivelabel"
                        defaultMessage="DDL File for Hive Database Development Test Enviroment"
                      />
                    </label>

                {/* <div className="" style={{ textAlign: 'center',with:'200px'}}> */}
                {/* <div style={{width:'%'}}
                    className="button-container1"
                    > */}
                    {MyUploader(props.match.params.reponame,props.username,uploadType, "internal_translation",repo,props.match.params.customer,
                      uploadcontent,setUploadcontent,_setDisableUploadBack,setPrjName,checkuploadinlist,disableUploadBack,
                      disableupload,setDisableupload,setDisabledownload,
                    ) }  

                    <button disabled={disabledownload}
                    className="button asse_upload3"
                    style={{ marginRight: '40px', marginLeft:'640px' }}
                    type="button"
                    onClick={() => sourceCodedownload(props.match.params.customer, props.match.params.reponame)}


                    // disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED'}
                  >
                    <FormattedMessage
                      id="dashboard.download.ddl"
                      defaultMessage="Download"
                    />
                  </button>
             



                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <Link to="/en-CA/datafactorymanagement">
                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '20px',marginLeft:'503px' }}
                     // onClick={showNPuploadFlase}
                      disabled={disableUploadBack}
                    >
                      back
                    </button>
                    </Link>
                    {/* <Link to="/en-CA/managementDDLjdbc2/${this.state.customer}"> */}
                    <Link style={(props.match.params.selectedjdbclength == 0)?{ pointerEvents: 'none' }:{}} 
                    to= {`/en-CA/managementDDLjdbc2/${dfid}/${reponame}/${props.match.params.customer}`}>
                    <button
                        disabled={props.match.params.selectedjdbclength == 0}
                      className="button"
                      type="button"
                      style={{ marginRight: '40px',marginLeft:'30px' }}
                     // onClick={showNPuploadFlase}
                     // disabled={disableUploadBack}
                    >
                      Next
                    </button>
                    </Link>
                  </div>
                {/* ) : null} */}

                {/* {!showUpload ? (
                  <LocalForm
                    className="form"
                    onSubmit={() =>
                      props.clickSubmitHandler(
                        props.username,
                        repo,
                        srclang,
                        targetLanguage,
                        description,
                        jobType,
                        stagingrepo,
                        customer,
                        repo,
                        showMessageTrue
                      )
                    }
                  >
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="onboard.organization"
                            defaultMessage="Organization Name: "
                          />
                        </label>

                        <Control.select
                          model=".customer"
                          autoFocus
                          required
                          value={customer}
                          onChange={selectCus}
                        >
                          {(customer === "" || customer === null) && <option value="">Please select organization name</option>}
                          {props.customersList.map(item => (
                            <option key={item["customer_id"]} value={item["customer_id"]}>
                              {item["company_name"]}
                            </option>
                          ))}
                        </Control.select>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="source.code.project.name"
                            defaultMessage="Source Code Repository Name: "
                          />
                        </label>

                        <Control.select
                          model=".reponame"
                          autoFocus
                          required
                          value={repo}
                          onChange={(e)=>{getStagingRepo(jobType,e.target.value);}}
                        >
                          {(repo === "" || repo === null) && <option value="">Please select project name</option>}
                          {props.customerprojectList.map(item => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Control.select>
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="assessment.stagingname"
                            defaultMessage="Source Code Staging Project Name:"
                          />
                        </label>

                        <Control.select
                          model=".staging"
                          autoFocus
                          required
                          value={stagingrepo}
                          onChange={(e) => (setStagingrepo(e.target.value))}
                        >
                          {(stagingrepo === "" || stagingrepo === null) && <option value="">Please select staging project name</option>}
                          {props.stagingprojectList.map(item => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Control.select>
                        <button
                          className="button asse_upload"
                          type="button"
                          onClick={showNPupload}
                          disabled={stagingrepo === ""}
                        >
                          Update source code
                        </button>
                      </fieldset>


                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="projects.project.source-languagee"
                            defaultMessage="Source Language: "
                          />
                        </label>

                        <Control.text
                          model=".srclang"
                          value={props.srclang}
                          disabled
                        >
                        </Control.text>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="projects.project.target-language"
                            defaultMessage="Target Language: "
                          />
                        </label>

                        <Control.text
                          model=".tgtlang"
                          value={props.tgtlang}
                          required
                          disabled
                        >
                        </Control.text>
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="comments.name"
                            defaultMessage="Description"
                          />
                        </label>

                        <Control.text
                          validators={{
                            length: val => `${val}`.length < 255
                          }}
                          model=".description"
                          value={props.description}
                          disabled
                        />
                      </fieldset>

                      <div className="button-container" style={{ textAlign: 'center' }}>
                        <button
                          className="button"
                          style={{ marginRight: '40px' }}
                          type="button"
                          onClick={() => props.clickBackHandler()}
                        >
                          <FormattedMessage
                            id="run-assessment.back.button.name"
                            defaultMessage="Back"
                          />
                        </button>

                        <button
                          className="button"
                          type="button"
                          onClick={()=>showNPupload("upload")}
                          style={{ marginRight: '40px' }}
                          disabled={repo === ""}
                        >
                          Upload source code
                        </button>

                        <button className="button" type="submit">
                          <FormattedMessage
                            id="submit.button.name"
                            defaultMessage="submit"
                          />
                        </button>
                      </div>
                    </div>
                  </LocalForm>
                ) : null} */}
              </div>
            )}

            {/* {showMessage && (
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%'
                  }}
                >
                  Your Commercial Code Translation request has been submitted.  The Commercial Code reference ID is  {refId}.  You will be notified via email once the SHIFT Commercial Code Translation is generated.

                </label>
                <br />
                &nbsp;
                <br />
                &nbsp;
                <div className="button-container" style={{ textAlign: 'center' }}>
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    type="button"
                    onClick={props.clickBackHandler}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            )} */}



          </div>
        </div>
        <Footer />
      </div>
    );
  }
  else{
    return (
      <div className="preview page">
        <Helmet>
          Translation - FUSE
        </Helmet>
        <Header
          title={messages.headerTitle}
          subtitle={messages.headerSubTitle}
          icon="preview"
          locale={props.locale}
          status = {props.status}
        />
        <ModalExample
          hasTitle
          confirmation
          infoText="Confirmation"
          className="modal_md"
          setClick={click => confirmation = click}
          confirmationSub = {confirmationSubmit}
          content={confirmationText}/>

        <div className="main">
          <div
            className="panel"
            style={{
              width: '90%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            {/* {!showMessage && ( */}
          {true && (
              <div>
                {showUpload ? (
                  <div className="form">
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="assessment.projectName"
                        defaultMessage="Project Name"
                      />
                    </label>
                    <Control.text
                      model=".projectName"
                      autoFocus
                      value={projectName}
                      placeholder={uploadType==='upload' ?"same as zip file name" : ""}
                      disabled
                    />
                    <br />
                    <br />
                    <br />
                    {MyUploader(projectName,props.username,uploadType,"translation","",props.customerid,
                      uploadcontent,setUploadcontent,_setDisableUploadBack,setPrjName,checkuploadinlist,disableUploadBack,
                      disableupload,setDisableupload
                    )}
                    <br />
                    <br />
                    <br />

                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={showUploadFalse}
                      disabled={disableUploadBack}
                    >
                      back
                    </button>
                  </div>
                ) : null}

                {/* {showEditor ? (
                  <div>
                    <Container >
                      <Row>
                        <Col xs="6">
                          <label>Code</label>
                          <AceEditor
                            mode="java"
                            theme="github"
                            placeholder="Copy And Paster Your Source Code Here."
                            // height = "610px"
                            width = "400px"
                            // onChange={onChange}
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            maxLines = {20000}
                          />
                        </Col>

                        <Col xs="6">
                          <label>Result</label>
                          <AceEditor
                            mode="java"
                            theme="github"
                            // height = "610px"
                            width = "400px"
                            // onChange={onChange}
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            readOnly
                            value="SELECT column1, column2, ...
                                    FROM table_name
                                    WHERE condition;"
                          />
                        </Col>
                      </Row>
                    </Container>
                    <br/>
                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={()=>setShowEditor(false)}
                    >
                      back
                    </button>
                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={()=>setShowEditor(false)}
                    >
                      Translate
                    </button>
                  </div>
                ) : null} */}

                {/* {!showEditor && !showUpload ? (
                  <div>
                    {!showFiles ? (
                      <LocalForm className="form">
                        <div
                          style={{
                            marginLeft: '3%'
                          }}
                        > */}
                          {/*  <i>*/}
                          {/*    <a*/}
                          {/*      // onClick={this.showUploadTrue}*/}
                          {/*      target="_blank"*/}
                          {/*      style={{*/}
                          {/*        color: 'rgb(68, 199, 244)',*/}
                          {/*        cursor: 'pointer',*/}
                          {/*        'textDecoration': 'underline'*/}
                          {/*      }}*/}
                          {/*    >*/}
                          {/*      Upload Source Code*/}
                          {/*    </a>*/}
                          {/*  </i>*/}
                          {/*  &nbsp;*/}
                          {/*  &nbsp;*/}
                          {/*  or*/}
                          {/*  &nbsp;*/}
                          {/*  &nbsp;*/}
                          {/*  <i>*/}
                          {/*    <a*/}
                          {/*      onClick={()=> setShowEditor(true)}*/}
                          {/*      target="_blank"*/}
                          {/*      style={{*/}
                          {/*        color: 'rgb(68, 199, 244)',*/}
                          {/*        cursor: 'pointer',*/}
                          {/*        'textDecoration': 'underline'*/}
                          {/*      }}*/}
                          {/*    >*/}
                          {/*      Copy And Paste Source Code For Translation*/}
                          {/*    </a>*/}
                          {/*  </i>*/}
                          {/*<br/>*/}
                          {/*<br/>*/}

                          {/* <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="source.code.project.name"
                                defaultMessage="Source Code Repository Name: "
                              />
                            </label>

                            <Control.select
                              model=".reponame"
                              required
                              value={repo}
                              onChange={changeRepo}
                            >
                              {(repo === "" || repo === null) && <option value="">Please select project name</option>}
                              {props.customerprojectList.map(item => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </Control.select>
                            <button
                              className="button asse_upload"
                              type="button"
                              onClick={()=>showUploadTrue("update")}
                              disabled={repo === ""}
                            >
                              Update source code
                            </button>
                          </fieldset>

                          <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="projects.project.source-languagee"
                                defaultMessage="Source Language: "
                              />
                            </label>

                            <Control.select
                              model=".srclang"
                              autoFocus
                              value={srclang}
                              onChange={(e)=>setSrclang(e.target.value)}
                              required
                            >
                              {(srclang === "" || srclang === null) && <option value="">Please select source language</option>}
                              <option value="teradata">Teradata</option>
                            </Control.select>

                          </fieldset>

                          <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="projects.project.target-language"
                                defaultMessage="Target Language: "
                              />
                            </label>

                            <Control.select
                              model=".tgtlang"
                              autoFocus
                              value={targetLanguage}
                              onChange={(e)=>setTargetLanguage(e.target.value)}
                              required
                            >
                              {(targetLanguage === "" || targetLanguage === null) && <option value="">Please select target language</option>}
                              <option value="RedShift">RedShift</option>
                            </Control.select>
                          </fieldset>

                          <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="comments.name"
                                defaultMessage="Description"
                              />
                            </label>
                            <Control.text
                              model=".description"
                              value={description}
                              onChange={e => setDescription(e.target.value)}
                            />
                          </fieldset>

                          <div className="button-container" style={{ textAlign: 'center' }}>
                            <button
                              className="button"
                              style={{ marginRight: '40px' }}
                              type="button"
                              onClick={() => props.clickBackHandler()}
                            >
                              <FormattedMessage
                                id="run-assessment.back.button.name"
                                defaultMessage="Back"
                              />
                            </button>

                            <button
                              className="button"
                              type="button"
                              style={{ marginRight: '40px' }}
                              onClick={()=>showUploadTrue("upload")}
                            >
                              Upload source code
                            </button>

                            <button
                              className="button"
                              type="submit"
                              onClick={gotoFileList}
                            >
                              <FormattedMessage
                                id="onboard.next"
                                defaultMessage="next"
                              />
                            </button>
                          </div>
                        </div>
                      </LocalForm>
                    ) : null} */}

                    {/* {showFiles && (
                      <div className="form">
                        <label
                          style={{
                            width: '90%',
                            fontSize: '16px',
                            textTransform: 'none',
                            lineHeight: '150%',
                            textAlign: 'center'
                          }}
                        >
                          Here is a list of files in your project. Please review before you click the Submit button.
                        </label>
                        <FilesTable
                          data={props.filesList}
                          deleteUser={props.deleteUser}
                          username={props.username}>
                        </FilesTable>

                        <div
                          className="button-container"
                          style={{ textAlign: 'center' }}
                        >
                          <button
                            className="button"
                            type="button"
                            style={{ marginRight: '40px' }}
                            onClick={() => setShowFiles(false)}
                          >
                            <FormattedMessage
                              id="run-assessment.back.button.name"
                              defaultMessage="Back"
                            />
                          </button>

                          <button
                            className="button"
                            type="button"
                            onClick={submitRequest}
                          >
                            <FormattedMessage
                              id="submit.button.name"
                              defaultMessage="Submit"
                            />
                          </button>
                        </div>
                      </div>
                    )} */}
                  </div>
                // ) : null}
              // </div>
            )}

            {/* {showMessage && (
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%'
                  }}
                >
                  Your Commercial Code Translation request has been submitted for review and will be sent to your Administrator for approval.
                  Your Commercial Code reference ID is  {refId}.  You will be notified via email when your request is approved.

                </label>
                <br />
                &nbsp;
                <br />
                &nbsp;
                <div className="button-container" style={{ textAlign: 'center' }}>
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    type="button"
                    onClick={props.clickBackHandler}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            )} */}

          </div>
        </div>
        <Footer />
      </div>
    );
  }

};

export default ManagementDDL;



// WEBPACK FOOTER //
// ./src/components/views/ManagementDDL/index.js